import React from 'react';
import { Dropdown, DropdownButton } from '@shared/components/dropdown';
import { grid } from '@shared/styles';
import { MBTextBody1 } from '../typography';
import { List } from './List';
import { Row } from './Row';
import { SortOptionsDropdown } from './SortOptionsDropdown';
import { ControlRow, SortOption } from './types';

interface SortRowProps extends ControlRow {
  sort: SortOption;
  availableSorts: SortOption[];
}

export function SortRow({ sort, onUpdate, onDelete, availableSorts }: SortRowProps) {
  const onSelect = (direction: SortOption['direction']) => {
    const newSortOption = { ...sort, direction };
    onUpdate(newSortOption);
  };

  return (
    <Row
      icon="arrows-up-down-swap"
      onDelete={() => onDelete({ ...sort, direction: undefined } as SortOption)}
    >
      <Dropdown
        button={({ onClick, isOpen }) => (
          <DropdownButton onClick={onClick} open={isOpen} style={{ marginRight: grid(1) }}>
            <MBTextBody1 numberOfLines={1}>{sort?.label}</MBTextBody1>
          </DropdownButton>
        )}
        closeOnSelect
      >
        <List
          options={availableSorts}
          selected={sort}
          onSelect={option => {
            onUpdate({ ...sort, ...option });
          }}
        />
      </Dropdown>
      <SortOptionsDropdown direction={sort.direction} onSelect={onSelect} />
    </Row>
  );
}
